import {Alert, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {AgentIncomeReportGrid} from "./grid";
import {submitAgentIncomeReport} from "../../../services/report/income";
import {CardFooterPaginator} from "../../system/cardFooterPaginator";


export function AgentIncomeReportManagement() {

  const [agentIncomeReport, setAgentIncomeReport] = useState([]);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);
  const [gridRowCount, setGridRowCount] = useState(5);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);

  const [personId, setPersonId] = useState(null);
  const [phone, setPhone] = useState(null);
  const [provinceId, setProvinceId] = useState(null);
  const [minBalance, setMinBalance] = useState(null);
  const [maxBalance, setMaxBalance] = useState(null);

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(data, paginate) {
    const result = await submitAgentIncomeReport(data, paginate);
    if (result.status === 200) {
      const {agent_report, total_count} = result.data;
      setAgentIncomeReport(agent_report || []);
      setGridTotalRowCount(total_count);
    }
  }

  const filter = () => {
    const data = {}
    if (personId) {
      data.person_id = personId;
    }

    if (phone) {
      data.phone = phone;
    }

    if (provinceId) {
      data.province_id = provinceId;
    }

    if (minBalance) {
      data.min_balance = parseInt(minBalance);
    }

    if (maxBalance) {
      data.max_balance = parseInt(maxBalance);
    }

    return data
  };

  useEffect(() => {
    const data = filter()
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(data, paginate)
  }, [personId, provinceId, minBalance, maxBalance, gridCurrentPage, gridRowCount, sortBy, sortType]);

  return (
    <div className="w-full">
      <Card className="pt-8 w-full">
        <CardHeader floated={true} shadow={false} className="flex flex-col rounded-none">
          <div className="mb-8 flex flex-row items-center justify-between gap-8">
            <Typography variant="h5" color="blue-gray">درآمد من</Typography>
          </div>
          <div className="flex-row w-fit justify-items-center">
            <Alert className="w-full" variant="outlined">
              <Typography className="w-full">
                مباشر گرامی، درآمد شما از مشاوره و خدمات ارائه شده، پس از تائید از سوی پلتفرم مباشر (ظرف 24 الی 72 ساعت
                کاری) در بخش درآمد من قابل مشاهده می باشد.
              </Typography>
            </Alert>
          </div>
        </CardHeader>
        <CardBody className="overflow-x-auto w-full">

          {/*<div className="grid grid-cols-1 gap-2 mb-2 md:grid-cols-3 xxl:grid-cols-3">*/}

          {/*  <div className="flex flex-col">*/}
          {/*    <SelectInput*/}
          {/*      label={"نام"}*/}
          {/*      defaultValue={personId}*/}
          {/*      refreshSignal={personId}*/}
          {/*      // multiselect={false}*/}
          {/*      autoLoadService={getPersonsNameAndFamily}*/}
          {/*      autoLoadRender={({name, family}) => {*/}
          {/*        return name + " " + family*/}
          {/*      }}*/}
          {/*      onChange={setPersonId}*/}
          {/*    />*/}
          {/*  </div>*/}

          {/*  <div className="flex flex-col">*/}
          {/*    <SelectInput*/}
          {/*      label={Dict("phone")}*/}
          {/*      defaultValue={personId}*/}
          {/*      refreshSignal={personId}*/}
          {/*      autoLoadService={getPersonsPhone}*/}
          {/*      autoLoadRender={({phone}) => {*/}
          {/*        return persianNumberFormat(phone)*/}
          {/*      }}*/}
          {/*      onChange={setPersonId}*/}
          {/*    />*/}
          {/*  </div>*/}

          {/*  <div className="flex flex-col">*/}
          {/*    <SelectInput*/}
          {/*      label={Dict("province")}*/}
          {/*      defaultValue={provinceId}*/}
          {/*      autoLoadService={getProvinces}*/}
          {/*      autoLoadRender={({title}) => {*/}
          {/*        return title*/}
          {/*      }}*/}
          {/*      onChange={setProvinceId}*/}
          {/*    />*/}
          {/*  </div>*/}

          {/*</div>*/}

          {/*<div className="grid grid-cols-1 gap-1 mb-2 md:grid-cols-2 xxl:grid-cols-2">*/}
          {/*  <FromToNumberField*/}
          {/*    label="موجودی"*/}
          {/*    fromNumber={minBalance}*/}
          {/*    setFromNumber={setMinBalance}*/}
          {/*    toNumber={maxBalance}*/}
          {/*    setToNumber={setMaxBalance}*/}
          {/*  />*/}
          {/*</div>*/}

          {/*<div className="flex flex-row">*/}
          {/*  <Button variant="gradient" color="gray" onClick={() => {*/}
          {/*    setPersonId(null)*/}
          {/*    setProvinceId(null)*/}
          {/*    setMinBalance(null)*/}
          {/*    setMaxBalance(null)*/}
          {/*  }} className="ml-1">*/}
          {/*    <span>حذف فیلتر</span>*/}
          {/*  </Button>*/}
          {/*</div>*/}

          <AgentIncomeReportGrid
            agentIncomeReport={agentIncomeReport}
            setSortBy={setSortBy}
            sortType={sortType}
            setSortType={setSortType}
          />
        </CardBody>
        <CardFooterPaginator
          active={gridCurrentPage}
          setActive={setGridCurrentPage}
          totalRows={gridTotalRowCount}
          rowsCount={gridRowCount}
          setRowsCount={setGridRowCount}
          from={from}
          to={to}
        />
      </Card>
    </div>
  );
}